// Add files here to allow one import line in another component to have access to all components in this folder

export { default as ActivityAndGeneralStatsDashboard } from "./ActivityAndGeneralStatsDashboard"
export { default as EmployeeEngagementDashboard } from "./EmployeeEngagementDashboard"
export { default as IntelAndInsightsDashboard } from "./IntelAndInsightsDashboard"
export { default as PeopleBalanceSheetDashboard } from "./PeopleBalanceSheetDashboard"
export { default as PerformanceAndProgressionDashboard } from "./PerformanceAndProgressionDashboard"
export { default as CustomReport } from "./CustomReport"



// WEBPACK FOOTER //
// ./src/routes/dashboards/index.js